'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';
const HeaderOracles = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div id="oracle-section" className="scroll-mt-[calc(var(--sticky-offset,0px)+16px)]"><SubSectionTitle>Oracle attributes</SubSectionTitle></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(HeaderOracles);